module.exports = __webpack_public_path__ + "media/images/front/logo_dba_sq-162ca1aaf5738a027d1485b190b0d297.png";